// extracted by mini-css-extract-plugin
export var black = "index-module--black--23bo6";
export var cls1 = "index-module--cls1--OADDr";
export var cls3 = "index-module--cls3--GAP17";
export var yellow = "index-module--yellow--uwOtv";